/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_CLIENTID,
        authority: process.env.REACT_APP_AZURE_AUTHORITY,
        redirectUri: `${process.env.REACT_APP_URL}`
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        allowRedirectInIframe: true,
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                // switch (level) {		
                //     case LogLevel.Error:
                //         // console.error(message);		
                //         return;		
                //     case LogLevel.Info:		
                //         // console.info(message);
                //         return;
                //     case LogLevel.Verbose:		
                //         // console.debug(message);		
                //         return;		
                //     case LogLevel.Warning:		
                //         // console.warn(message);		
                //         return;		
                // }	
            }
        }
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me?$select=employeeId,mail,surname,givenName,mobilePhone,businessPhones,department",
    graphUsersEndPoint:'https://graph.microsoft.com/v1.0/users?$select=employeeId,mail,surname,givenName,mobilePhone,businessPhones,department&'
};




/* CognitoURL */
export const cognitoURL = `${process.env.REACT_APP_COGNITO_URI}/oauth2/token`;

/* cognitoトークン取得リダイレクトURL */
export const cognitoRedirectURI = `${process.env.REACT_APP_URL}/authct`;

/* cognitoログアウトリダイレクトURL */
export const cognitoLogoutRedirectURI = `${process.env.REACT_APP_URL}`;

/* cognitoクライアントID */
export const cognitoClientId = `${process.env.REACT_APP_COGNITO_CLIRNTID}`;

/* cognito認証URL */
export const cognitoAuthenticateURL = `${process.env.REACT_APP_COGNITO_URI}/oauth2/authorize?response_type=code&response_mode=query&scope=email+openid&client_id=${cognitoClientId}&redirect_uri=${cognitoRedirectURI}&identity_provider=${process.env.REACT_APP_COGNITO_IDPROVIDER}&state=1129`
export const cognitoSignOutURL = `${process.env.REACT_APP_COGNITO_URI}/logout?client_id=${cognitoClientId}&logout_uri=${cognitoLogoutRedirectURI}`;


/* cogniton Authorization */
export const cognitoAuthorization = `Basic ${process.env.REACT_APP_COGNITO_AUTHORIZATION}`
